import { render, staticRenderFns } from "./ConfirmWizard.vue?vue&type=template&id=106f5330&scoped=true"
import script from "./ConfirmWizard.vue?vue&type=script&lang=js"
export * from "./ConfirmWizard.vue?vue&type=script&lang=js"
import style0 from "./ConfirmWizard.vue?vue&type=style&index=0&id=106f5330&prod&lang=scss"
import style1 from "./ConfirmWizard.vue?vue&type=style&index=1&id=106f5330&prod&lang=scss&scoped=true"
import style2 from "./ConfirmWizard.vue?vue&type=style&index=2&id=106f5330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106f5330",
  null
  
)

export default component.exports